import React from "react"
import { RadioButton } from "primereact/radiobutton"

const InputRadioButton = (props) => {
  return <RadioButton {...props} />
}

export default InputRadioButton
